import LogOutPanel from './LogOutPanel';

export default LogOutPanel;
